import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
type ArtifactCardProps = {
  title: string;
  children: ReactNode;
};
const ArtifactCard = t0 => {
  const $ = _c(8);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="flex items-center px-4 py-3 md:px-5 md:py-4"><h3 className="text-heading-5 text-primary">{title}</h3></div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mx-4 md:mx-5 border-t border-tertiary" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <div className="flex-1 min-h-0 overflow-auto p-4 md:p-5">{children}</div>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className="flex flex-col max-h-full border border-tertiary rounded-lg bg-primary overflow-hidden">{t1}{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default ArtifactCard;